import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InteractionRequiredAuthError, SilentRequest } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';
import { Observable, catchError, from, switchMap, throwError } from 'rxjs';
import { resolveScopesForUrl } from 'src/msal-config';

const AUTH_RETRY = new HttpContextToken<boolean>(() => false);

@Injectable()
export class AuthRecoveryInterceptor implements HttpInterceptor {
  constructor(private readonly msalService: MsalService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (!(error instanceof HttpErrorResponse) || error.status !== 401 || request.context.get(AUTH_RETRY)) {
          return throwError(() => error);
        }

        const scopes = resolveScopesForUrl(request.url);
        const account = this.msalService.instance.getActiveAccount()
          ?? this.msalService.instance.getAllAccounts()[0];

        if (!scopes || !account) {
          return throwError(() => error);
        }

        const tokenRequest: SilentRequest = {
          account,
          scopes,
          forceRefresh: true
        };

        return from(this.msalService.instance.acquireTokenSilent(tokenRequest)).pipe(
          switchMap((result) => {
            const retryRequest = request.clone({
              context: request.context.set(AUTH_RETRY, true),
              setHeaders: {
                Authorization: `Bearer ${result.accessToken}`
              }
            });

            return next.handle(retryRequest);
          }),
          catchError((refreshError: unknown) => {
            if (refreshError instanceof InteractionRequiredAuthError) {
              void this.msalService.instance.acquireTokenRedirect({
                account,
                scopes,
                redirectStartPage: window.location.href
              });
            }

            return throwError(() => refreshError);
          })
        );
      })
    );
  }
}
